import React from 'react';
import { TableRow, TableBody } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { PluginComponent } from 'plugins';
import { getReasonCodes } from 'reducers/reasonCodesDB';
import { REASONS } from 'constants/reasonCodesDB';
import { getProductCodeToShowOnReturnModal } from 'reducers/configs/settings';

import { StyledTable, StyledCell, StyledTableHead, Checkbox } from '../styled';
import { useReturnRows } from '../useReturnRows';

import OrderProduct from './OrderProduct';

type Props = {
  hideReturnReasons: boolean;
  globalReturnReason: string | undefined;
};

const DesktopTable: React.FC<Props> = ({
  hideReturnReasons,
  globalReturnReason,
}) => {
  const { t } = useTranslation('return', { keyPrefix: 'headings' });

  const returnCodeReasons = useSelector(getReasonCodes(REASONS.RETURN));
  const codeToShow = useSelector(getProductCodeToShowOnReturnModal);

  const { computedRows, toggleAllRows, areAllSelected } = useReturnRows();

  return (
    <StyledTable>
      <StyledTableHead>
        <TableRow>
          <PluginComponent hookname="UISelectAllCheckBoxForReturns">
            <StyledCell style={{ textOverflow: 'unset' }}>
              <Checkbox
                onChange={toggleAllRows}
                checked={areAllSelected}
                data-testid="toggle-rows"
              />
            </StyledCell>
          </PluginComponent>
          <StyledCell>{t('product')}</StyledCell>
          <StyledCell>{t(codeToShow)}</StyledCell>
          <StyledCell>{t('originalQty')}</StyledCell>
          <StyledCell>{t('qty')}</StyledCell>
          {returnCodeReasons.length > 0 && !hideReturnReasons ? (
            <StyledCell>{t('reason')}</StyledCell>
          ) : null}
        </TableRow>
      </StyledTableHead>
      <TableBody>
        {computedRows.map(row => (
          <OrderProduct
            key={row.rowID}
            row={row}
            isEven={row.isEven}
            hideReturnReasons={hideReturnReasons}
            globalReturnReason={globalReturnReason}
          />
        ))}
      </TableBody>
    </StyledTable>
  );
};

export default DesktopTable;
